import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareChangelogQuery } from '@entities/changelog'

import { defineNuxtRouteMiddleware } from '#app'

/** `/subscriptions/{id}/changelog` — the changelog table reads this subscription's own actions. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const subscriptionId = to.params.id

  if (typeof subscriptionId !== 'string' || !subscriptionId) return

  useMiddlewareChangelogQuery(to, {
    route: 'admin.subscription.changelog',
    params: { subscription_id: subscriptionId },
  })
})
